
import { Calendar } from "primereact/calendar";
import { useLazyGetUserECGDataQuery } from "../api/healthDataApi";
import { useEffect, useState } from "react";
import { ECGGraph } from "../views/ECGGraph";
import Loading from "components/commons/Loading";
import { useTranslation } from "react-i18next";

const ECGMeasurements = ({
    ecgList,
    date,
    onDateChange = (e) => { }
}) => {

    const [t] = useTranslation(["global", "health"]);
    const [ecgGuid, setECGGuid] = useState(ecgList[0]?.guid || "")
    const [fetchECGData, { data: ecg, isSuccess, isFetching }] = useLazyGetUserECGDataQuery();

    useEffect(() => {

        if (ecgGuid == "")
            return

        let selectedEcg = ecgList.filter(ecg => ecg.guid == ecgGuid)[0]

        fetchECGData({
            userGuid: selectedEcg.user.guid,
            start: selectedEcg.startTime,
            end: selectedEcg.endTime
        })

    }, [ecgGuid])

    useEffect(() => {
        setECGGuid("")

    }, [date])

    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">

        <div className="d-flex  justify-content-between mb-3" id="ecg">
            <div>
                <h4><i className="fa-solid fa-heart-pulse text-muted"></i> {t("health:entity.data.ECG")}</h4>
                <span className="small text-muted">{ecgList.length} {t("health:unit.measurements", { count: ecgList.length })}</span>
            </div>

            <div className="">
                {
                    ecgList.length > 0 ?
                        <select className="form-select" aria-label="Default select example" value={ecgGuid} onChange={(e) => setECGGuid(e.target.value)}>
                            <option value=""> {t("health:helper.select_ecg")}</option>
                            {
                                ecgList.map(ecg => (<option key={ecg.guid} value={ecg.guid}>{new Date(ecg.startTime).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })} - {Math.round((ecg.endTime - ecg.startTime) / 1000)} s</option>))
                            }
                        </select> : <h6> {t("health:helper.no_ecg")}</h6>
                }

            </div>

            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>



        </div>

        {
            isSuccess && !isFetching && ecgList.length != 0 && ecgGuid &&
            <ECGGraph ecg={ecg} />
        }

        {
            isFetching &&
            <Loading />
        }

    </div>
}

export default ECGMeasurements